import React from "react";
import Information from "../Information";
import Store from "../../../content/Store";
import Content from "../../../content/Content";
import ErrorContentLinks from "./sharedErrorContent/ErrorContentLinks";

export const RestrictedPolicy = () => {
  return (
    <Information headerText={Store.ErrorPages.RestrictedPolicy.HeaderText}>
      <Content name={Store.ErrorPages.RestrictedPolicy.Message} />
      <ErrorContentLinks />
    </Information>
  );
};
